import { signal } from '@preact/signals';
import type { JSX } from 'preact/jsx-runtime';

let notificationId = 1;

export interface Notification {
    id: number;
    title?: string | JSX.Element;
    content: string | JSX.Element;
    durationInSeconds?: number;
    actionButton?: JSX.Element;
    hasActionButton?: boolean;
    type: 'success' | 'error' | 'info';
    classnames?: string[];
    icon?: JSX.Element;
    onClick?: () => void;
}

export const notifications = signal<Notification[]>([]);

export function addNotification(notification: Omit<Notification, 'id'>) {
    notifications.value = [...notifications.value, { id: notificationId++, ...notification }];
}

export function removeById(id: number) {
    notifications.value = notifications.value.filter((n) => n.id !== id);
}
